import { Component, Vue } from 'vue-property-decorator'
import { queryClassSummary, queryClassPaperSend, evaluationPlanBrandomText, editNotePlanBclassDetail, editNotePaperSend, paperMasterPlanBCommit, evaluationPlanBclassDetail, getUrlpaperMaster } from '@/api'
// import paperFeedBack from '@/components/paperFeedBack/index.vue'
@Component({ name: 'class-detail-page' })
export default class ClassDetailPage extends Vue {
  private classData: any = {}
  private activeweek: any = 0
  private currentStudentPage: any = 1
  private allStudentPage: any = 1
  private activeStudent: any = {}
  private dialogImageUrl: any = null
  private dialogVisible: any = null
  private NotePaperSend: any = false
  private cityOptions: any = ['上海', '北京', '广州', '深圳']
  private checkedCities: any =['上海', '北京']
  // 班级课程内容
  private classPaperData: any = {}
  // 论文投递
  private paperDelivery: any = {}
  private paperUrl: any = null
  private urlVisible: any =false

  created () {
    // 班级详情
    this.initPageData()
    // 论文投递数据
    this.initClassPaperSend()
    // 课程内容
    this.initPaperClassDetail()
  }

  private async initPageData () {
    const result: any = await queryClassSummary({ classId: this.$route.query.classId })
    this.classData = result
  }

  private async initClassPaperSend () {
    const result = await queryClassPaperSend({ classId: this.$route.query.classId })
    this.classPaperData = result
  }

  private async initPaperClassDetail () {
    const result = await evaluationPlanBclassDetail({ classId: this.$route.query.classId })
    this.paperDelivery = result
  }

  // 保存班级课程内容
  private async saveClassContent () {
    const { error }: any = await editNotePlanBclassDetail({ changeList: this.paperDelivery, classId: this.$route.query.classId })
    if (!error) {
      this.$message({ type: 'success', message: '保存课程内容成功', duration: 3000 })
    }
  }

  private async PlanBrandomText (val: any, type: any, val1: any) {
    if (val.answer.length && type === 1) {
      const obj = val.answer[val.answer.length - 1]
      const result: any = await evaluationPlanBrandomText({ chooseItem: obj, questionId: val.questionId })
      this.$set(obj, 'detail', result)
    } else {
      const obj: any = val1.chooseList.find((item: any) => item.id === val.answerId)
      const result: any = await evaluationPlanBrandomText({ chooseItem: obj, questionId: val.questionId })
      this.$set(obj, 'detail', result)
      val.answer = [obj]
    }
  }

  private async getURL () {
    const result: any = await getUrlpaperMaster({ classId: this.$route.query.classId })
    if (result && !result.error) {
      this.paperUrl = result
      this.urlVisible = true
    }
  }

  // 保存班级论文投递
  private async saveNotePaperSen () {
    const { error }: any = await editNotePaperSend({ changeList: this.classPaperData.question })
    if (!error) {
      this.NotePaperSend = true
    }
  }

  private async copylink () {
    const url: any = this.$refs.url
    url.select()
    document.execCommand('Copy')
    this.$message({ message: '复制成功', type: 'success' })
  }

  // 发送班级反馈
  private async sureSendClassClick (type: any) {
    await this.saveNotePaperSen()
    if (this.NotePaperSend) {
      const { error }: any = await paperMasterPlanBCommit({ classId: this.$route.query.classId, messageType: type })
      if (!error) {
        this.$message({ type: 'success', message: type === 1 ? '发送论文投递成功' : '更新论文投递成功' })
      }
      this.NotePaperSend = false
    }
  }
}
